/* Info component on the ScenesPage */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const Information = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col md={{span: 8, offset: 2}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>PRODUCTION TRACKER</p>
          <hr className={`mt-2 mb-0`}/>
           <p className="pt-2"><span className={`${styles.Red}`}>*</span> Production Items are designed and collaborated on by Scene
           in each <span className={`${styles.Red}`}>Scene Workshop</span>.
           </p>
           <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Production Tracker</span> to log and track Production 
            Items by Scene and Department.
           </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Add the items with a Minor, Medium or Major <span className={`${styles.Red}`}>Label</span> depending
            on the size or importance of the Item and set its <span className={`${styles.Red}`}>Status</span> to New.
            </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Once work begins on the Item set the status to Started, and when
              work is completed set it to Done.
            </p>
            <p className="pt-2">
            <span className={`${styles.Red}`}>*</span> Major project elements, such as Locations, Characters or Props should be collaborated 
            on in the Scene where they <span className={`${styles.Red}`}>first</span> appear in the Script.
            </p>
            <hr className={`mt-2 mb-0`}/>
           </div> 
        </Col>
      </Row>
    </div>
  )
}

export default Information